import { createEnumNormalizer } from '@change-corgi/config/fcm/normalizers';

import { createFcmConfig } from '../shared/factory';

export const FCM_STARTER_SAP_PHONE_COLLECTION = createFcmConfig('starter_sap_phone_collection', {
	normalizer: createEnumNormalizer(['off', 'optional', 'mandatory']),
	defaultValue: 'off' as const,
});
